import $ from 'jquery';
import {
  customCursor
} from '../components/cursor.js';
import {
  burgerToggle
} from '../components/burger.js';
import {
  blackHeader
} from '../components/black-header.js';
import {
  toggleParent
} from '../components/toggle-parent.js';
import {
  swiper
} from '../components/swiper.js';
import {
  accordion
} from '../components/accordion.js';
import {
  smartPanel
} from '../components/smart-panel.js';
import {
  openPopup
} from '../components/popup.js';
import {
  successPopup
} from '../components/success.js';
import {
  inputMask
} from '../components/inputMask.js';
import {
  anchor
} from '../components/anchor.js';
import {
  ajaxOwlCarousel
} from '../components/owlReview.js';
import {
  panelOpen
} from '../components/panel-open.js';
import {
  cookie
} from '../components/cookie.js';
import {
  lang
} from '../components/lang.js';
import {
  confidentiality
} from '../components/confidentiality.js';

import 'owl.carousel';
import { currency } from '../components/currency.js';
import { accordionVacancy } from '../components/accordion-vacancy.js';

global.$ = global.jQuery = $;

document.addEventListener("DOMContentLoaded", () => {
  customCursor.init();
  burgerToggle.init();
  blackHeader.init();


  toggleParent($('.header-dropdown__title'), '.header-dropdown');
  accordion($('.faq-section__title'), '.faq-section__item', '.faq-section__text');
  accordion($('.program__subtitle'), '.program__item', '.lesson');
  accordionVacancy();
  //accordion($('.title_wrapper'), '.vacancy-item', '.text');
  smartPanel();
  openPopup('.copyright__button', '.popup-question');
  openPopup('.mail-popup', '.popup-consultation');
  openPopup('.phone-popup', '.popup-callback');
  openPopup('.home-intro__logo', '.popup-course');
  openPopup(null, '.popup-cv');
  successPopup();
  inputMask();
  anchor();
  panelOpen();
  cookie();
  currency();
  lang();
  confidentiality();

  new swiper($('.toggle-nav__inner'));

  ajaxOwlCarousel();
});


// WEBPACK FOOTER //
// app/scripts/pages/index.js